import config from '@/config';

import { QuizzesResponse } from '@/types/response';
import { SkillService } from '@/types/services';
import axiosInstance from '@/utils/api-new';
import UserUtils from '@/utils/user';
import { UserState } from '@/types/user';
import { updateActivityResponseData } from './utils';

export const skillService: SkillService = {
  //fetchQuizzes
  fetchGameTopic: async (
    user: UserState | null,
    level: number,
    unitId: number,
    topicId: number
  ) => {
    const resp: QuizzesResponse | null | any = await axiosInstance.get(
      //FIXME: NEED TO USE REAL ID IN FEATURE
      `${config.apiVersion}/${UserUtils.fromToLanguage(user)}/game-content/${level}/${unitId}/${topicId}`
    );

    const mockResp = {
      // gameType: 0,
      nameLocal: '',
      name: 'Yes / No Questions',
      description: 'Interrogative Sentence Structure',
      descriptionLocal: '',
      urlName: 'Yes_NoQuestions',
    };

    const tempData = { ...resp };

    const tempContent = tempData.data.data;

    for (let index = 0; index < tempContent.length; index++) {
      tempContent[index] = {
        ...mockResp,
        ...resp.data.data[index],
        name: tempContent[index].title,
        order: +tempContent[index].order,
      };
    }

    return tempData;
  },
  //fetchQuestions
  fetchGameActivity: async (
    user: UserState | null,
    level: number,
    unitId: number,
    topicId: number,
    quizId: number
  ) => {
    const resp: QuizzesResponse | null | any = await axiosInstance.get(
      `${config.apiVersion}/${UserUtils.fromToLanguage(user)}/game-content/${level}/${unitId}/${topicId}/${quizId}`
    );

    let tempContent = structuredClone(resp.data.data);

    //FIXME: New API response is () example:
    //   {
    //     "image_description": "An ear with sound waves coming in.",
    //     "image": "https://ell-dev.melingo.com/1/get-base64-image?imagePath=listen.jpg",
    //     "imageSource": null
    // }

    for (let index = 0; index < tempContent.length; index++) {
      //FIXME: Helper for make new responce structure to old one + add "newData" property. Need to be fixed in feature
      updateActivityResponseData(tempContent, index, resp.data.data);

      if (index + 1 >= tempContent.length) {
        tempContent = {
          quizId,
          questions: tempContent,
          hasScore: resp.data?.hasScore,
        };

        return tempContent;
      }
    }
  },
  sendOpenWritingAnswer: async (user: UserState | null, payload: any) => {
    const resp: any | null = await axiosInstance.post(
      `${config.apiVersion}/${UserUtils.fromToLanguage(
        user
      )}/grading/open-writing/${user?.metadata.id}`,
      payload
    );
    return resp;
  },
};
